<div class="p-6 flex-table-page" data-testid="o2o-change-history-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "o2o.change_history.title" | translate }}
  </h2>

  <app-search-form
    data-testid="o2o-change-history-search"
    [searchFormat]="searchConfig"
    [presetValues]="searchPreset"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="o2o-change-history-table"
      [dataSource]="rows()"
      [defaultColumns]="columns"
      [flexibleColumns]="[]"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column && column.template === "dateTemplate") {
          <span class="text-xs text-gray-600">
            {{ formatDateTime(value) }}
          </span>
        } @else if (column && column.template === "orderLinkTemplate") {
          @if (rowData?.orderId || rowData?.innerOrderNo) {
            <button
              type="button"
              class="text-sm text-blue-600 hover:underline"
              (click)="openOrder(rowData)"
            >
              {{ value || "—" }}
            </button>
          } @else {
            <span class="text-sm">{{ value || "—" }}</span>
          }
        } @else if (column && column.template === "noteTemplate") {
          <p-tag
            [value]="formatNote(value)"
            [severity]="noteSeverity(value)"
          ></p-tag>
        } @else if (column && column.template === "valueTemplate") {
          <span
            class="text-xs text-gray-700 whitespace-pre-line"
            [title]="formatChangeValue(value)"
          >
            {{ formatChangeValue(value) }}
          </span>
        } @else if (column && column.template === "userTemplate") {
          <span class="text-sm">
            {{
              rowData?.fullName ||
                rowData?.userName ||
                ("o2o.change_history.table.system_actor" | translate)
            }}
          </span>
        }
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast></p-toast>
